import './Logo.css'

export function Logo() {
  return <h1 className="logo-title">gleam</h1>
}
